module.exports = __webpack_public_path__ + "static/media/webdesign-services-img41.4c083627.jpg";